// global
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown } from 'semantic-ui-react';
//style
import styles from './dropdown.module.scss';
class CustomDropdown extends React.Component {
  state = {
    searchQuery: '',
    props: this.props
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ searchQuery: '', props: nextProps });
  }

  handleSearch = (e, { searchQuery }) => this.setState({ searchQuery });

  render() {
    const { searchQuery, props } = this.state;
    const {
      isForm,
      error,
      searchable,
      noResultsMessage,
      styleName,
      required,
      placeholder,
      options,
      value,
      disabled,
      ...rest
    } = props;
    const CustomDropdown = isForm ? Form.Dropdown : Dropdown;
    const hasError = error ? 'error' : '';
    const className = [styleName, hasError]
      .filter(s => s.length > 0)
      .map(c => styles[c])
      .join(' ');

    const getTitle = value => {
      const option = options.find(option => option.value === value);
      return option ? option.text : '';
    };

    return (
      <CustomDropdown
        {...rest}
        title={getTitle(value) ? getTitle(value) : placeholder}
        value={value}
        placeholder={placeholder}
        options={options}
        search={searchable}
        required={required}
        searchQuery={searchQuery}
        onSearchChange={this.handleSearch}
        className={className}
        noResultsMessage={noResultsMessage ? noResultsMessage : 'Termo não encontrado.'}
        disabled={disabled}
      />
    );
  }
}

CustomDropdown.defaultProps = {
  isForm: true,
  disabled: false,
  searchable: true,
  styleName: 'styleModal'
};

CustomDropdown.propTypes = {
  isForm: PropTypes.bool,
  searchable: PropTypes.bool,
  noResultsMessage: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.any,
  placeholder: PropTypes.string,
  styleName: PropTypes.oneOf([
    'styleModal',
    'styleReport',
    'styleListDropdown',
    'styleMedicineItem',
    'styleReportGeneration',
    'stylePepIndividualView',
    'styleReportSettings',
    'styleReportFilters',
    'styleCreatePad',
    'styleReportPad'
  ])
};

export default memo(CustomDropdown);
